import { render, staticRenderFns } from "./PublishableEntityHistory.vue?vue&type=template&id=0683d6b0"
import script from "./PublishableEntityHistory.vue?vue&type=script&lang=js"
export * from "./PublishableEntityHistory.vue?vue&type=script&lang=js"
import style0 from "./PublishableEntityHistory.vue?vue&type=style&index=0&id=0683d6b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports